import "../App.css";
import React from "react";
import { write, useSnap } from "../store";
import Rec from "../recordings/rec";
import SingleQ from "./singleQ";
import CD from "../components/cd";
// import Modal from "../components/Modal";
import NewModal from "../components/newModal";
import { locale } from "../components/locale";
import posthog from 'posthog-js';

function Questions() {
  const read = useSnap();
  const progressPercent = `${((read.currentQuestion * 100) / read.totalQuestions) < 5 ? '5%' : `${(read.currentQuestion * 100) / read.totalQuestions}%`}`;


  React.useEffect(() => {
    if (read.questions[read.currentQuestion - 1]?.questionType !== 'speaking' && read.questions[read.currentQuestion - 1]?.questionType !== 'listening') {
      write.stopTimer = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [read.currentQuestion]);


  // console.log('🧯🧯' , read.page)

  const RenderIt = React.useCallback(() => {
    // console.log(read.totalQuestions , read.currentQuestion)
    if (read.questions[read.currentQuestion - 1].questionType === "reading") {
      write.currentQuestionType = `${locale[read.user.language].titles.reading
        }📖`;
    }
    if (read.questions[read.currentQuestion - 1].questionType === "listening") {
      write.currentQuestionType = `${locale[read.user.language].titles.listening
        }👂`;
    }
    if (read.questions[read.currentQuestion - 1].questionType === "writing") {
      write.currentQuestionType = `${locale[read.user.language].titles.writing
        }✍️`;
    }
    if (read.questions[read.currentQuestion - 1].questionType === "speaking") {
      write.currentQuestionType = `${locale[read.user.language].titles.speaking
        }🗣️`;
    }
    return (
      <>
        <SingleQ
          questionData={read.questions[read.currentQuestion - 1]}
          type={read.questions[read.currentQuestion - 1].questionType}
        />
        {/* <Modal type = {read.questions[read.currentQuestion - 1].questionType} /> */}
        <NewModal
          type={read.questions[read.currentQuestion - 1].questionType}
          title={`${read.questions[read.currentQuestion - 1].questionType
            } section instruction`}
        />
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [read.currentQuestion]);


  React.useEffect(() => {
    if (read.OS !== "iOS" && read.OS !== "Android") {
      return undefined;
    }
    if (!navigator.permissions || !navigator.permissions.query) {
      return undefined;
    }

    const permissionCheckInterval = setInterval(async () => {
      try {
        const camPerm = await navigator.permissions.query({ name: "camera" });
        camPerm.state !== 'granted' && (write.page = 'CAMMICOFF')
      } catch (_error) {
        // Some mobile browsers do not support querying camera permission.
      }
    }, 3000);

    return () => clearInterval(permissionCheckInterval);
  }, [read.OS]);


  React.useEffect(() => {
    let visibilityHidden, visibilityChange;
    // Opera 12.10 and Firefox 18 and later support
    if (typeof document.hidden !== "undefined") {
      visibilityHidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") {
      visibilityHidden = "mozHidden";
      visibilityChange = "mozvisibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      visibilityHidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      visibilityHidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }

    function fn() {
      if (document[visibilityHidden]) {
        write.tabControl++
        posthog.capture('tab_switch_detected', {
          invitation_id: write.id,
          tab_switch_count: write.tabControl,
          question_index: write.currentQuestion - 1,
        });
      }
    }

    function handleResize() {
      // If window width is significantly smaller than screen width, it might be side-by-side
      if (window.innerWidth < window.screen.width * 0.85) {
        write.resizeControl++
        posthog.capture('window_resize_detected', {
          invitation_id: write.id,
          resize_count: write.resizeControl,
          question_index: write.currentQuestion - 1,
          inner_width: window.innerWidth,
          screen_width: window.screen.width,
        });
      }
    }

    document.addEventListener(visibilityChange, fn)
    window.addEventListener('resize', handleResize)
    return () => {
      document.removeEventListener(visibilityChange, fn);
      window.removeEventListener('resize', handleResize);
    }
  }, []);


  // console.log('🙈🙈🙈🙈', read.tabControl , `w-${Math.ceil(read.currentQuestion / read.totalQuestions)}/12`)



  return (
    <>
      <div className="questions-page-shell flex w-full flex-col items-center gap-2 px-2 pb-6 sm:px-5 md:px-6">
        <div className="questions-topbar question-control-rail w-full max-w-5xl rounded-2xl border border-white/70 bg-white/90 px-2 py-2 shadow-xl shadow-slate-900/10 backdrop-blur-sm sm:px-3">
          <div className="flex min-h-[3.5rem] w-full items-center gap-2 sm:min-h-[4rem] sm:gap-3">
            <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
              <pre className="min-w-0 flex-1 truncate whitespace-nowrap font-sans text-base font-black leading-tight text-slate-950 sm:text-xl md:text-2xl" title={read.currentQuestionType}>
                {read.currentQuestionType}
              </pre>
              <div className="inline-flex flex-shrink-0 items-center rounded-full bg-slate-900 px-2 py-1 text-[10px] font-black uppercase tracking-[0.14em] text-white sm:px-3 sm:text-xs">
                {`${read.currentQuestion} / ${read.totalQuestions}`}
              </div>
            </div>
            {read.questions[read.currentQuestion - 1] && (
              <div className='question-timer-card flex flex-shrink-0 items-center justify-center rounded-2xl border border-white/70 bg-white/95 p-1 text-green-600 shadow-lg shadow-slate-900/10 backdrop-blur-sm'>
                <CD />
              </div>
            )}
          </div>
        </div>
        <div className="question-progress-strip relative h-3 w-full max-w-5xl overflow-hidden rounded-full bg-slate-200/80 shadow-inner shadow-slate-900/10">
          <div
            className="question-progress-fill h-full rounded-full transition-[width] duration-300"
            style={{
              // width: `${(read.currentQuestion * 100) / read.totalQuestions}%`,
              width: progressPercent
            }}
          />
          <div className="question-progress-marker absolute top-1/2 z-20 -translate-x-1/2 -translate-y-1/2" style={{ left: progressPercent }}>
            <div className="question-progress-marker-shell flex h-4 w-4 items-center justify-center rounded-full">
              <svg
                aria-hidden="true"
                className="h-2.5 w-2.5"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="2" y="2" width="6" height="6" rx="1" transform="rotate(45 5 5)" fill="#F5C24B" />
              </svg>
            </div>
          </div>
          <div className="question-progress-text absolute inset-0 z-10 flex items-center justify-center font-black leading-none tracking-[0.16em]">
            {`${read.currentQuestion}/${read.totalQuestions}`}
          </div>
        </div>
        <div className="flex w-full flex-col items-center md:max-w-full">
          {read.questions[read.currentQuestion - 1] && <RenderIt />}
        </div>
      </div>
      <Rec />
    </>
  );
}

export default Questions;

//  {/* <SingleQ questionData={read.questions[read.currentQuestion - 1]} />  */}

//     {/* read.questions.map((q , i)=>{
//         return(
//          (read.currentQuestion - 1) === i && <SingleQ key={i} questionData={q} />
//         )
//       }) */}
